import { makeStyles } from '@material-ui/styles';

export default makeStyles(theme => ({
  paper: {
    backgroundColor: theme.palette.colors.background,
    display: 'flex',
    flexDirection: 'column',
  },
  content: {
    height: theme.settings.size.mobile.NonAuthPaperHeight,
    [theme.breakpoints.up('mobile')]: {
      height: theme.settings.size.desktop.NonAuthPaperHeight,
    },
  },
}));



// WEBPACK FOOTER //
// ./src/layouts/NonAuthLayout/useStyles.js